export default __webpack_public_path__ + "static/media/userIcon.d2ee6df4.svg";